module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.woff2?f80b8a05dd76fdb40e630f1e90b1303d";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff2
// module id = tNtp
// module chunks = 29